import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from '@/App';
import { setLocaleSource } from '@/lib/api/client';
import i18n, { resolveLocale } from '@/lib/i18n/config';
import '@/styles/globals.css';

// Wired here rather than inside the client so that module stays free of i18n,
// and so the language the API answers in always matches the chrome around it.
setLocaleSource(() => resolveLocale(i18n.language));

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element #root is missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
